import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.marketplace}tickets`;

export interface SnoozeTicketCommandArgs {
  id: string;
  date: string;
}

export const snoozeTicketRequest = (
  payload: SnoozeTicketCommandArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.id}/snooze`,
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { snoozeUntilDateUtc: payload.date },
  },
});

export const snoozeTicketCommand = async (
  payload: SnoozeTicketCommandArgs,
): Promise<BaseBackResponse> => {
  try {
    return await executeQuery<BaseBackResponse>(snoozeTicketRequest(payload));
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
